import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import type { SubscriptionStatus } from './types';
import { subscriptionStatusQueryKey } from './query-keys';
export const SUBSCRIPTION_STATUS_STALE_TIME_MS = 5 * 60 * 1000;
export const SUBSCRIPTION_STATUS_LIVE_REFETCH_INTERVAL_MS = 60 * 1000;
type UseSubscriptionStatusOptions = {
  live?: boolean;
};
export function useSubscriptionStatus(installationId, t0) {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const isLive = options.live !== false;
  let t2;
  if ($[2] !== installationId) {
    t2 = subscriptionStatusQueryKey(installationId);
    $[2] = installationId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== installationId) {
    t3 = async () => {
      if (!installationId) {
        throw new Error("Installation ID is required");
      }
      const response = await fetch(`/api/billing/subscription-status?installationId=${installationId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch subscription status");
      }
      return response.json();
    };
    $[4] = installationId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !!installationId;
  const t5 = isLive ? SUBSCRIPTION_STATUS_LIVE_REFETCH_INTERVAL_MS : SUBSCRIPTION_STATUS_STALE_TIME_MS;
  const t6 = isLive ? SUBSCRIPTION_STATUS_LIVE_REFETCH_INTERVAL_MS : false;
  let t7;
  if ($[6] !== isLive || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = {
      queryKey: t2,
      queryFn: t3,
      placeholderData: _temp,
      enabled: t4,
      staleTime: t5,
      refetchOnWindowFocus: isLive,
      refetchOnMount: isLive,
      refetchInterval: t6
    };
    $[6] = isLive;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return useQuery(t7);
}
function _temp() {}